'use strict';

var toastr = require('toastr');
var ToastrConfig = function ToastrConfig() {
  toastr.options = {
    'closeButton': true,
    'debug': false,
    'progressBar': false,
    'positionClass': 'toast-bottom-right',
    'onclick': null,
    'showDuration': '3000',
    'hideDuration': '1000',
    'timeOut': '5000',
    'extendedTimeOut': '1000',
    'showEasing': 'swing',
    'hideEasing': 'linear',
    'showMethod': 'fadeIn',
    'hideMethod': 'fadeOut'
  };
};
ToastrConfig.$inject = [];
module.exports = ToastrConfig;